<template>
  <div class="flex justify-center items-center">
    <div
      class="z-40 bg-[#EC4E20] rounded-[10px] text-lg w-screen mx-5 min-h-[56px] flex justify-center items-center max-w-[90%]"
    >
      <div class="flex flex-row w-full my-[4px]">
        <div class="flex justify-center items-center min-w-[30px]">
          <img
            src="/assets/icons/event-page/announcement-icon.svg"
            class="w-[32px] h-[32px] ml-[8px]"
          />
        </div>
        <div
          class="rich-text-content ml-[12px] text-white text-wrap max-w-[80%]"
          v-html="renderedBodyText"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { convertStoryblokRichTextToHtml } from '@/utils/storyblokRichText';

export default {
  name: 'AnnouncementSection',
  props: {
    bodyText: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    renderedBodyText() {
      return convertStoryblokRichTextToHtml(this.bodyText);
    },
  },
};
</script>

<style scoped>
.rich-text-content :deep(ul) {
  list-style-type: disc;
  padding-left: 1.25rem;
  margin: 0.5rem 0;
}

.rich-text-content :deep(ol) {
  list-style-type: decimal;
  padding-left: 1.25rem;
  margin: 0.5rem 0;
}

.rich-text-content :deep(li) {
  display: list-item;
  margin: 0.2rem 0;
}

.rich-text-content :deep(p) {
  margin: 0.35rem 0;
}

.rich-text-content :deep(li > p) {
  margin: 0;
}
</style>
